/* eslint-disable react/prop-types */
import React, { useEffect } from 'react'
import { Formik } from 'formik'
// import { useLoginUserMutation } from '../../../reduxStore/reduxToolkitQuery'
import { validationSchema } from './validationSchema'
// import { setProfile } from '../../../reduxStore/slices/generalSlice'
// import { Alert } from 'react-bootstrap'
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
  CSpinner,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilLockLocked } from '@coreui/icons'
// import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
// import { setAdminToken, setAdminType } from '../../../reduxStore/slices/generalSlice'
import { useVerificationCodeVerificationMutation } from 'src/reduxStore/reduxToolkitQuery'
import { ToastContainer, toast } from 'react-toastify'

const VerificationCode = () => {
  // const location = useLocation()
  // const params = new URLSearchParams(location.search)
  // const [showRepeatPasswordAlert, setShowRepeatPasswordAlert] = useState(() =>
  //   params.get('msg') != null ? true : false,
  // )
  // const [alertMsg, setAlertMsg] = useState(() => params.get('msg'))
  const history = useHistory()
  const notifyError = (message) => toast.error(message)
  const notifySuccess = (msg) => toast.success(msg)
  useEffect(() => {}, [])
  // const dispatch = useDispatch()
  const initialValues = {
    verificationCode: '',
  }
  const [verify, { isLoading: verifyLoading }] = useVerificationCodeVerificationMutation()
  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={8}>
            <CCard className="p-4">
              <CCardBody>
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={async (values, actions) => {
                    // const { newPassword, confirmNewPassword } = values
                    // console.log('passwords: ', newPassword, confirmNewPassword)
                    //set verification code in the local storage for future use
                    localStorage.setItem('resetPasswordNumber', parseInt(values.verificationCode))
                    const result = await verify({
                      resetPasswordNumber: parseInt(values.verificationCode),
                      email: localStorage.getItem('email') || 'NO EMAIL',
                    }).unwrap()
                    console.log('RESULT: ', result)
                    if (result.status === 'success') {
                      // navigate to the reset password screen
                      notifySuccess('Verification is done, you are redirecting...')
                      setTimeout(() => {
                        history.push('/forgot-password-confirm')
                      }, 3000)
                    }
                    if (result.status === 'failure') {
                      notifyError('SOMETHING WENT WRONG, TRY AGAIN')
                    }
                  }}
                >
                  {(props) => (
                    <CForm onSubmit={props.handleSubmit}>
                      <h1>Verification Code</h1>
                      <p className="text-medium-emphasis">
                        Enter the verification code you found in your Email
                      </p>
                      <CInputGroup className="mb-3">
                        <CInputGroupText>
                          <CIcon icon={cilLockLocked} />
                        </CInputGroupText>
                        <CFormInput
                          name="verificationCode"
                          value={props.values.verificationCode}
                          onChange={props.handleChange}
                          onBlur={props.handleBlur}
                          type="text"
                          placeholder="Verification Code"
                          autoComplete="verificationCode"
                        />
                      </CInputGroup>
                      <div className="text-danger mb-3">
                        {props.touched.verificationCode &&
                          props.errors.verificationCode &&
                          props.errors.verificationCode}
                      </div>
                      <CButton
                        type="submit"
                        color="primary"
                        disabled={verifyLoading || props.values.verificationCode.length === 0}
                      >
                        {verifyLoading && <CSpinner size="sm" component="span" />}
                        Verify
                      </CButton>
                    </CForm>
                  )}
                </Formik>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
      <ToastContainer />
    </div>
  )
}

export default VerificationCode
